<template>
  <div class="test-email-preset">
    <div class="header">
      <div class="sub-header">
        <h5>テスト送信先<span class="count">{{count}}/{{limit}}</span></h5>
        <div class="operation-area">
          <div
            class="sort normal-btn"
            @click="isShowSortSelect = !isShowSortSelect"
            v-on-clickaway="sortSelectAway"
          >
            並び替え
            <transition>
              <ul class="sort-option drop-down-list" v-show="isShowSortSelect">
                <li :class="{ selected: sort.index === 0 }" @click="changeSort(0, 'manual', 'asc')">指定順</li>
                <li :class="{ selected: sort.index === 1 }" @click="changeSort(1, 'innerId', 'asc')">ID昇順</li>
                <li :class="{ selected: sort.index === 2 }" @click="changeSort(2, 'innerId', 'desc')">ID降順</li>
                <li :class="{ selected: sort.index === 3 }" @click="changeSort(3, 'name', 'asc')">名前昇順</li>
                <li :class="{ selected: sort.index === 4 }" @click="changeSort(4, 'name', 'desc')">名前降順</li>
                <li :class="{ selected: sort.index === 5 }" @click="changeSort(5, 'createdOn', 'asc')">作成日時昇順</li>
                <li :class="{ selected: sort.index === 6 }" @click="changeSort(6, 'createdOn', 'desc')">作成日時降順</li>
                <li :class="{ selected: sort.index === 7 }" @click="changeSort(7, 'createdUserName', 'asc')">作成者名昇順</li>
                <li :class="{ selected: sort.index === 8 }" @click="changeSort(8, 'createdUserName', 'desc')">作成者名降順</li>
                <li :class="{ selected: sort.index === 9 }" @click="changeSort(9, 'savedOn', 'asc')">更新日時昇順</li>
                <li :class="{ selected: sort.index === 10 }" @click="changeSort(10, 'savedOn', 'desc')">更新日時降順</li>
                <li :class="{ selected: sort.index === 11 }" @click="changeSort(11, 'modifiedUserName', 'asc')">更新者名昇順</li>
                <li :class="{ selected: sort.index === 12 }" @click="changeSort(12, 'modifiedUserName', 'desc')">更新者名降順</li>
              </ul>
            </transition>
          </div>
          <div class="search">
            <input
              type="text"
              placeholder="検索"
              v-model="model.searchText"
              @keydown.enter="$utils.event.strictEnter($event, getTestEmailPresets)"
            />
            <button @click="getTestEmailPresets"><i class="fas fa-search"></i></button>
          </div>
        </div>
      </div><!-- .sub-header -->
      <div class="check-wrapper">
        <ul class="batch">
          <li v-if="testEmailPresets.length > 0">
            <input
              id="all-checked"
              type="checkbox"
              @change="check = $event.target.checked"
              :checked="check !== 0 && check === testEmailPresets.length"
            />
            <label for="all-checked"></label>
          </li>
          <li
            v-if="check"
            class="delete normal-btn"
            @click="deleteConfirm(false)"
          >
            <span>削除</span>
          </li>
        </ul>
        <div class="add">
          <input
            type="text"
            placeholder="テスト送信先を追加"
            v-model="model.name"
            @keydown.enter="$utils.event.strictEnter($event, addName)"
          />
          <button @click="addName" class="w-b-btn">追加</button>
        </div>
      </div><!-- .check-wrapper -->
    </div><!-- .header -->
    <div class="test-email-preset-main">
      <template v-if="!isNoTestEmailPresets">
        <ul>
          <draggable
            v-model="testEmailPresets"
            handle=".test-email-preset-handle"
            :disabled="model.searchText"
            @end="onDraggableEnd"
          >
            <li
              v-for="(testEmailPreset, index) in testEmailPresets"
              :key="index"
            >
              <div class="checkbox">
                <input
                  type="checkbox"
                  v-model="testEmailPreset.checked"
                  :name="index"
                  :id="index"
                />
                <label :for="index"></label>
              </div>
              <div class="box-wrapper">
                <div class="info">
                  <div class="id"><span>ID</span>{{testEmailPreset.innerId}}</div>
                  <div class="name-box">
                    <span>{{ testEmailPreset.name }}</span>
                  </div>
                  <div class="create">
                    <span>作成</span>
                    <span>{{ testEmailPreset.createdOn }}</span>
                    <span>{{ testEmailPreset.createdUserName }}</span>
                  </div>
                  <div class="update">
                    <span>更新</span>
                    <span>{{ testEmailPreset.savedOn }}</span>
                    <span>{{ testEmailPreset.modifiedUserName }}</span>
                  </div>
                </div><!-- .info -->
                <div class="emails-box">
                  <span
                    v-for="(email, index) in testEmailPreset.preset.split(',')"
                    :key="index"
                    :class="{'isMac': isMac}"
                  >{{ email }}</span>
                </div>
                <ul class="img-nav">
                  <li @click="showInputPopup(testEmailPreset)">編集</li>
                  <li @click="deleteConfirm(testEmailPreset)">削除</li>
                </ul>
                <div
                  v-if="sort.index === 0"
                  @mousedown="clickDragHandle"
                  class="test-email-preset-handle"
                  title="ドラッグ＆ドロップで並び順を変更"
                />
              </div><!-- .box-wrapper -->
            </li>
          </draggable>
        </ul>
      </template>
      <template v-else>
        <div class="no-test-email-presets">
          <p>テスト送信先がありません</p>
        </div>
      </template>
    </div><!-- .test-email-preset-main -->
    <portal v-if="isShowInputPopup" to="modal1">
      <modal @close="isShowInputPopup = false" class="input-popup">
        <template slot="input">
          <div class="form">
            <input
              class="name"
              type="text"
              placeholder="テスト送信先名称"
              v-model="inputPopup.name"
            />
            <p v-if="inputPopup.errorMessages.name" class="error-message">{{ inputPopup.errorMessages.name }}</p>
            <p class="emailDescription">メールアドレス</p>
            <tag-like-email-input :default-emails="inputPopup.defaultEmails" ref="tagLikeEmailInput" />
            <p class="notice">
              最大{{ maxTestEmailCount }}件まで指定できます (<span
                class="count"
                :class="{'red': emails.length > maxTestEmailCount}"
              >{{ emails.length }}/{{ maxTestEmailCount }}</span>)
            </p>
            <p v-if="inputPopup.errorMessages.email" class="error-message">{{ inputPopup.errorMessages.email }}</p>
          </div>
        </template>
        <template slot="submit">
          <div class="button-box">
            <button type="button" @click="save" class="submit normal-btn">保存</button>
            <button type="button" @click="isShowInputPopup = false" class="cancel normal-btn">キャンセル</button>
          </div>
        </template>
      </modal>
    </portal>
    <portal v-if="isShowDeletePopup" to="modal2">
      <modal @close="isShowDeletePopup = false">
        <template slot="title">削除確認</template>
        <template slot="name">テスト送信先 {{ deletes.length }} 件を本当に削除してもよろしいでしょうか?</template>
        <template slot="submit">
          <div class="button-box">
            <button type="button" @click="deletePreset" class="delete normal-btn">削除</button>
            <button type="button" @click="isShowDeletePopup = false" class="cancel normal-btn">キャンセル</button>
          </div>
        </template>
      </modal>
    </portal>
  </div><!-- .test-email-preset -->
</template>

<script>
import { mixin as onClickAway } from 'vue-clickaway'
import Modal from '@/components/Util/Modal'
import Draggable from 'vuedraggable'
import TagLikeEmailInput from '@/components/Util/TagLikeEmailInput'
import constants from '@/constants'

const MAX_TEST_EMAIL_PRESET_NAME_LENGTH = 25

const SORTS = [
  ['manual', 'asc'],
  ['innerId', 'asc'],
  ['innerId', 'desc'],
  ['name', 'asc'],
  ['name', 'desc'],
  ['createdOn', 'asc'],
  ['createdOn', 'desc'],
  ['createdUserName', 'asc'],
  ['createdUserName', 'desc'],
  ['savedOn', 'asc'],
  ['savedOn', 'desc'],
  ['modifiedUserName', 'asc'],
  ['modifiedUserName', 'desc'],
]

const initialData = () => {
  return {
    isNoTestEmailPresets: false,
    isShowSortSelect: false,
    isShowInputPopup: false,
    isShowDeletePopup: false,
    maxTestEmailCount: constants.maxTagLikeEmailCount,
    model: {
      name: '', // 追加ボタン横のテスト送信先名
      searchText: '',
    },
    sort: {
      index: 0,
      target: 'manual',
      type: 'asc',
    },
    testEmailPresets: [],
    deletes: [],
    count: null,
    limit: null,
    sortOption: false,
    batchTestEmailPresetOption: false,
    inputPopup: {
      name: '', // ポップアップの中のテスト送信先名
      editId: null,
      defaultEmails: [],
      isSending: false,
      errorMessages: {
        name: '',
        email: '',
      },
    },
  }
}

export default {
  mixins: [
    onClickAway
  ],
  components: {
    Modal,
    Draggable,
    TagLikeEmailInput,
  },
  data () {
    return initialData()
  },
  computed: {
    isMac () {
      return window.navigator.platform.toLowerCase().includes('mac')
    },
    emails () {
      return this.$store.state.tagLikeEmailInput.emails
    },
    check: {
      get: function () {
        return this.testEmailPresets.filter(testEmailPreset => (testEmailPreset.checked)).length
      },
      set: function (value) {
        this.testEmailPresets.forEach(testEmailPreset => { testEmailPreset.checked = value })
      }
    },
  },
  created () {
    this.initComponent()
  },
  methods: {
    initComponent () {
      this.getDefaultDisplay().then(() => this.getTestEmailPresets())
    },
    sortSelectAway () {
      this.isShowSortSelect = false
    },
    onDraggableEnd () {
      let count = 1
      const formData = new FormData()
      this.testEmailPresets.forEach(testEmailPreset => {
        testEmailPreset.sort = count++
        formData.append('testEmailPresetIds[]', testEmailPreset.id)
      })
      this.$http({
        url: `/test_email_preset/sort/`,
        type: 'POST',
        params: formData
      })
    },
    clickDragHandle () {
      if (this.model.searchText) {
        this.$store.commit('showErrorMessagePopup',
          ['絞り込み中は並び替え操作ができません']
        )
      }
    },
    getDefaultDisplay () {
      return this.$http({
        url: '/user/mphe_settings/default_display_test_email_preset',
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          const { sortTarget, sortType } = json.data.display
          this.sort = {
            index: SORTS.findIndex(sort => sort[0] === sortTarget && sort[1] === sortType),
            target: sortTarget,
            type: sortType
          }
        }
        return json
      })
    },
    changeSort (index, target, type) {
      this.isShowSortSelect = false
      this.sort = { index, target, type }
      this.getTestEmailPresets()

      // 並び替え設定を保存
      const formData = new FormData()
      formData.append('testEmailPresetSortTarget', target)
      formData.append('testEmailPresetSortType', type)
      this.$http({
        url: '/user/mphe_settings/change_default_display',
        type: 'POST',
        params: formData,
      })
    },
    addName () {
      if (!this.model.name) {
        return this.$store.commit('showErrorMessagePopup',
          ['テスト送信先が入力されていません']
        )
      } else if ([...this.model.name].length > MAX_TEST_EMAIL_PRESET_NAME_LENGTH) {
        return this.$store.commit('showErrorMessagePopup',
          ['テスト送信先は最大' + MAX_TEST_EMAIL_PRESET_NAME_LENGTH + '字までです']
        )
      }
      this.showInputPopup()
    },
    showInputPopup (testEmailPreset = null) {
      this.$store.commit('clearTagLikeEmailInput')
      if (testEmailPreset) {
        // 編集向け
        this.inputPopup = {
          name: testEmailPreset.name,
          editId: testEmailPreset.id,
          defaultEmails: testEmailPreset.preset.split(','),
          isSending: false,
          errorMessages: {
            name: '',
            email: '',
          },
        }
      } else {
        // 新規向け
        this.inputPopup = {
          name: this.model.name,
          editId: null,
          defaultEmails: [],
          isSending: false,
          errorMessages: {
            name: '',
            email: '',
          },
        }
      }
      // いずれの場合も、追加ボタン横のテスト送信名は空にする
      this.model.name = ''

      this.isShowInputPopup = true
    },
    validate () {
      let isValid = true
      if (!this.inputPopup.name) {
        this.inputPopup.errorMessages.name = 'テスト送信先名が入力されていません'
        isValid = false
      } else if ([...this.inputPopup.name].length > MAX_TEST_EMAIL_PRESET_NAME_LENGTH) {
        this.inputPopup.errorMessages.name = 'テスト送信先名は最大' + MAX_TEST_EMAIL_PRESET_NAME_LENGTH + '字までです'
        isValid = false
      }
      if (this.emails.some(tag => tag.text.length > constants.maxEmailLength)) {
        this.inputPopup.errorMessages.email = 'テスト送信先は最大' + constants.maxEmailLength + '字までです'
        isValid = false
      } else if (this.emails.length > this.maxTestEmailCount) {
        this.inputPopup.errorMessages.email = 'テスト送信先は最大' + this.maxTestEmailCount + '件までです'
        isValid = false
      } else if (this.emails.length === 0) {
        this.inputPopup.errorMessages.email = 'テスト送信先が入力されていません'
        isValid = false
      } else if (!this.$store.getters.isValidTagLikeEmailInput) {
        this.inputPopup.errorMessages.email = '無効なテスト送信先が入力されています'
        isValid = false
      }
      return isValid
    },
    async save () {
      await new Promise(resolve => setTimeout(resolve, 50)) // store が更新されるまで待つ
      if (!this.validate()) return
      if (this.inputPopup.isSending) return
      const formData = new FormData()
      formData.append('name', this.$utils.string.b64Encode(this.inputPopup.name))
      formData.append('preset', this.emails.map(obj => obj.text).join(','))
      // エラーポップアップを抑制
      formData.append('formValidationKeys[]', 'email')
      this.inputPopup.isSending = true
      let json = null
      if (this.inputPopup.editId) {
        // 編集
        json = await this.$http({
          url: '/test_email_preset/save/' + this.inputPopup.editId,
          type: 'POST',
          params: formData,
        })
      } else {
        // 新規
        json = await this.$http({
          url: '/test_email_preset/new/',
          type: 'POST',
          params: formData,
        })
      }
      if (json.status === 200) {
        this.getTestEmailPresets()
        this.isShowInputPopup = false
      } else {
        this.inputPopup.errorMessages.email = json.validations.email
      }
      this.inputPopup.isSending = false
    },
    getTestEmailPresets () {
      return this.$http({
        url: `/test_email_preset/?searchText=${this.model.searchText}&sortTarget=${this.sort.target}&sortType=${this.sort.type}`,
        type: 'GET',
      }).then(json => {
        if (json && json.status === 200) {
          this.testEmailPresets = json.data.testEmailPresets.map(testEmailPreset => {
            return {
              ...testEmailPreset,
              name: this.$utils.string.b64Decode(testEmailPreset.name),
              checked: false,
              showInput: {
                name: false,
              }
            }
          })
          this.count = json.data.count
          this.limit = json.data.limit
          this.isNoTestEmailPresets = (this.testEmailPresets.length === 0)
        }
      })
    },
    deleteConfirm (testEmailPreset = false) { // 明示的に指定
      // 単体で削除 or チェックボックスで選択
      this.deletes = testEmailPreset ? [ testEmailPreset ] : this.testEmailPresets.filter(testEmailPreset => (testEmailPreset.checked))
      this.isShowDeletePopup = true
    },
    deletePreset () {
      const formData = new FormData()
      this.deletes.map(testEmailPreset => {
        formData.append('testEmailPresetIds[]', testEmailPreset.id)
        return testEmailPreset.id
      })
      this.$http({
        url: `/test_email_preset/delete/`,
        type: 'POST',
        params: formData
      }).then(json => {
        if (json && json.status === 200) {
          this.getTestEmailPresets()
          this.deletes = []
        }
        this.isShowDeletePopup = false
      })
    },
    batchTestEmailPresetHidden () {
      this.batchTestEmailPresetOption = false
    },
  },
}
</script>
<style lang="scss" scoped>
.test-email-preset {
  font-size: 14px;
  position: relative;
  .header {
    .sub-header {
      position: relative;
      margin-bottom: 20px;
      h5 {
        display: flex;
        align-items: center;
        padding-left: 20px;
        margin-bottom: 20px;
        font-size: 24px;
        span {
          display: inline-block;
          margin-right: 8px;
          height: 22px;
          line-height: 22px;
          &.count {
            font-size: 12px;
            border-radius: 13px;
            padding: 0 8px;
            margin-left: 8px;
            background: #e4e4e4;
          }
        }
      }
      // 検索と並べ替え
      .operation-area {
        position: absolute;
        top: 0;
        right: 0;
        .search {
          width: 400px;
          height: 35px;
          margin-right: 20px;
          display: block;
          position: relative;
          &>input {
            width: 100%;
            padding:0 10px;
            border-radius:2px;
            height: 35px;
            outline:0;
            background: #E4E4E4;
            position: absolute;
            left: 0;
            top: 0;
            &::-webkit-input-placeholder {
              position: relative;
              top: 0.05em;
            }
          }
          &>button {
            width: 50px;
            height: 35px;
            border-radius:0 2px 2px 0;
            outline:0;
            position: absolute;
            right: -20px;
            top: 0;
            background: none;
            transition: all 0.3s ease 0s;
            cursor: pointer;
            &:hover, &:active {
              background: #c6c6c6;
              transition: all 0.3s ease 0s;
            }
          }
        }
        .sort {
          margin: 0 0 20px auto;
          &::before {
            content: '\f161';
            font-family: "Font Awesome 5 Free";
            font-weight: 900;
          }
          .sort-option {
            right: 0;
            left: auto;
            width: 83px;
            li {
              position: relative;
              width: 100%;
              &.selected::before {
                content: '\f00c';
                font-family: "Font Awesome 5 Free";
                font-weight: 900;
                position: absolute;
                top: 0;
                left: -15px;
              }
            }
          }
        }
      }
    }
    // 一括操作のチェックボックス
    input[type=checkbox] {
      display:  none;
      + label {
        padding-left: 10px;
        font-size: 12px;
        margin-bottom: 0;
        display: inherit;
        line-height: 20px;
        &::before {
          width: 20px;
          height: 20px;
          box-sizing: border-box;
          vertical-align: bottom;
          margin-right: 8px;
          display: inline-block;
          content: '';
          border-radius: 4px;
          background: #cfcfcf;
        }
      }
      &:checked + label::before {
        font-size: 14px;
        font-family: "Font Awesome 5 Free";
        padding-left: 3px;
        content: '\f00c';
        display: inline-block;
        font-weight: 900;
      }
    }
    .check-wrapper {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .batch {
        display:flex;
        align-items: center;
        margin: 0 0 0 20px;
        width: 150px;
        li:not(:first-of-type) {
          span {
            display: inline-block;
            &::before, &::after {
              font-family: "Font Awesome 5 Free";
              font-weight: 900;
            }
            &::before {
              padding-right: 5px;
            }
          }
          &.delete {
            width: 80px;
            span::before {
              content: '\f2ed';
            }
          }
        }
      }
    }
    .add {
      width: 300px;
      height: 35px;
      margin-right: 48px;
      display: flex;
      &>input {
        width: 100%;
        padding:0 10px;
        border-radius:2px;
        height: 35px;
        outline:0;
        background: #E4E4E4;
        margin-right: 5px;
      }
      &>button {
        border-radius: 2px;
        opacity: 1;
        cursor: pointer;
        transition: all 0.3s ease 0s;
        &:hover, &:active {
          opacity: 0.8;
        }
      }
    }
  }
  .test-email-preset-main {
    margin-bottom: 60px;
    a {
      color: $commonFontColor;
    }
    .no-test-email-presets {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        font-size: 14px;
      }
    }
    >ul {
      > div > li {
        background: #f8f8f8;
        padding: 15px 20px;
        padding-right: 0;
        border-bottom: 0.5px solid #C6C6C6;
        margin: 0 20px;
        position: relative;
        &:first-of-type {
          border-top: 0.5px solid #C6C6C6;
        }
        // 一括操作のチェックボックス
        .checkbox {
          position: absolute;
          top:20px;
          left: 10px;
          input[type=checkbox] {
            display:  none;
            + label {
              font-size: 12px;
              margin-bottom: 0;
              display: inherit;
              line-height: 20px;
              &::before {
                width: 20px;
                height: 20px;
                vertical-align: bottom;
                margin-right: 8px;
                display: inline-block;
                content: '';
                border-radius: 4px;
                background: #cfcfcf;
              }
            }
            &:checked + label::before {
              font-size: 14px;
              font-family: "Font Awesome 5 Free";
              padding-left: 3px;
              content: '\f00c';
              display: inline-block;
              font-weight: 900;
            }
          }
        }
        .box-wrapper {
          margin-left: 30px;
          display:flex;
          align-items: center;
        }
        .info {
          display: inline-block;
          flex: 1;
          // min-width: 360px;
          .name-box {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
            display: flex;
            > div {
              overflow: hidden;
            }
          }
          button {
            display: inline;
          }
          .id, .create, .update {
            span {
              margin-right: 8px;
              &:first-of-type{
                display: inline-block;
                text-align: center;
                width: 40px;
                height: 21px;
                border-radius: 12px;
                background: #e4e4e4;
              }
              &:last-of-type {
                margin-right: 10px;
              }
            }
          }
          .id {
            font-size: 12px;
            color: rgba(#484848, 0.6);
            span {
              &:first-of-type {
                width: 30px;
                height: 19px;
              }
            }
          }
          .create, .update {
            margin-bottom: 2px;
            display: flex;
            span:nth-of-type(2) {
              min-width: 150px;
            }
            span:nth-of-type(3) {
              width: 150px;
              // ...省略
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
        .emails-box {
          width: 100%;
          flex: 1;
          overflow: hidden;
          span {
            overflow-wrap: break-word;
            display: inline;
            margin: 0 4px 4px 0;
            padding: 3px 7px;
            font-size: 16px;
            line-height: 32px;
            border-radius: 2px;
            background: #e4e4e4;
            &.isMac {
              line-height: 28px;
            }
          }
        }
        // 右側のメニュー
        .img-nav {
          display:flex;
          margin: 0;
          > li {
            width: 96px;
            height: 54px;
            white-space: nowrap;
            font-weight: 300;
            border-radius: 2px;
            transition: all 0.3s ease 0s;
            text-align: center;
            padding-top: 12px;
            margin: 0 10px 0 10px;
            cursor: pointer;
            &:hover, &:active {
              background: #e4e4e4;
              transition: all 0.3s ease 0s;
              border-radius: 2px;
            }
            &::before {
              font-family: "Font Awesome 5 Free";
              display: block;
              text-align: center;
            }
            &:nth-of-type(1)::before {
              content: '\f044';
              font-weight: 900;
            }
            &:nth-of-type(2)::before {
              content: '\f2ed';
            }
          }
          margin-right: 60px;
        }
        .test-email-preset-handle {
          position: absolute;
          top: 59px;
          right: 1px;
          width: 40px;
          &::before {
            color: $commonFontColor;
            content: '\f0dc';
            cursor: pointer;
            font-family: "Font Awesome 5 Free";
            font-size: 24px;
            font-weight: 900;
          }
        }
      }
    }
  }
}
.form {
  position: relative;
  min-height: 100px;
  .name {
    width: 237px;
    height: 35px;
    padding: 0 10px;
    border-radius: 2px;
    height: 35px;
    outline: 0;
    background: #E4E4E4;
  }
  .emailDescription {
    margin-top: 5px;
  }
  .notice {
    font-size: 14px;
    margin-top: 5px;
    .count {
      color: #000;
      &.red {
        color: #ff0000;
      }
    }
  }
}
.button-box {
  display: flex;
  justify-content: center;
  button {
    font-size: 14px;
    border: solid 1px #c6c6c6;
    border-radius: 5px;
    &:hover {
      opacity: 0.8;
    }
    &.submit {
      margin-right: 20px;
      color: #fff;
      border: solid 1px #484848;
      background: #484848;
      &:disabled {
        border: solid 1px #6c757d;
        background: #6c757d;
        opacity: 0.8;
        cursor: default;
      }
    }
    &.delete {
      margin-right: 20px;
      color: #fff;
      border: solid 1px #484848;
      background: #484848;
    }
  }
}
.error-message {
  display: block;
  line-height: 2;
  max-width: 410px;
}
</style>

<style lang="scss">
.input-popup {
  #modal-content {
    width: 600px;
  }
}
</style>
